import AddressInfo from "./AddressInfo";

const DeliveryAddresses = ({ cartSummary }) => {
    
    const locations = cartSummary
    .map(cart => (cart.lines && cart.lines.length ? cart.location : undefined))
    .filter(Boolean);
    
    return (
        <div  className="cart-table border border-gray-100 rounded-8 px-20 py-28">  
            <h6 className="text-xl mb-32">Delivery address</h6>                  
            {locations?.length > 0 ? (
                <div>
                    {locations.map((location, index) => (
                        <div key={index} className="flex p-10">
                            <h6>{location?.name_secondary || location.name}</h6>                     
                            <AddressInfo                                
                                {...location}
                                {...(location?.delivery_address || {})}
                            />
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-gray-500">No delivery locations found.</p>
            )}
        </div>
    );
};

export default DeliveryAddresses;
